import Controller from '@ember/controller';

export default class AuthenticatedProjectsShowProjectVersionsShowBouncesIndexController extends Controller {}
